import { OnInit, Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'video-wyswyg',
  templateUrl: './video-wyswyg.component.html',
  styleUrls: ['./video-wyswyg.component.css']
})
export class VideoWyswygComponent extends ElementComponent implements OnInit {
  @Input() override data: any = {
    src: '',
    ytVideoId: '',
    vimeoVideoId: ''
  }

  public tempUrl: string = '';

  ngOnInit(): void {
    this.updateUrl(this.data.src);
  }

  saveUrl(): void {
    this.updateUrl(this.tempUrl);
  }

  isYtVideo(): boolean {
    return !!this.data.src && !!this.data.ytVideoId && this.data.ytVideoId !== ''
  }

  isVimeoVideo(): boolean {
    return !!this.data.src && !!this.data.vimeoVideoId && this.data.vimeoVideoId !== ''
  }

  private updateUrl(url: string): void {
    this.data.ytVideoId = this.youtube_parser(url);
    this.data.vimeoVideoId = this.vimeo_parser(url);
    this.data.src = url;
  }

  private youtube_parser(url): string {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : '';
  }

  private vimeo_parser(url: string): string {
    var regExp = /https?:\/\/(www\.)?vimeo.com\/(channels\/(?:\w+\/)?|groups\/(?:\w+\/)?|album\/(?:\d+\/)?video\/|video\/|)(\d+)(?:$|\/|\?)/;
    var match = url.match(regExp);
    return (match && match[3]) ? match[3] : '';
  }
}
